import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Address } from "components/Address/Address";
import { Button } from "components/Button/Button";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { DataGrid } from "components/DataGrid/DataGrid";
import Datepicker from "components/DatePicker/DatePicker";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
import { FormWithTitle } from "components/FormWithTitle/FormWithTitle";
import { Headerbar } from "components/Headerbar/Headerbar";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Position } from "components/Position/Position";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { ContactType, MessageType } from "types/enum";
import { GUID_EMPTY, ICON_TYPE, INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { convertAddress, RoundOutputOperation, trans, uuidv4 } from "utils/helpers";
import { CustomerTabform } from "../../BaseDefinitionAndSetting/Customers/CustomerTabForm";
import { CurrencyDictionary } from "../../PriceList/components/CurrencyDictionary/CurrencyDictionary";
import { PriceListDictionary } from "../../PriceList/components/PriceListDictionary/PriceListDictionary";
import { AddressBox } from "../../SalesInvoice/components/AddressBox/AddressBox";
import { CustomerDictionary } from "../../SalesInvoice/components/CustomerDictionary/CustomerDictionary";
import { CustomerPhoneDictionary } from "../../SalesInvoice/components/CustomerPhoneDictionary/CustomerPhoneDictionary";
import { CustomerPhoneList } from "../../SalesInvoice/components/CustomerPhones/CustomerPhoneList";
import { getDefaultPersonContact, getPersonCustomer } from "../api";
import { DocsClassification } from "../components/DocsClassification/DocsClassification";
import { SalesContractDetailForm } from "../SalesContractDetailForm";
import { PriceInput } from "components/PriceInput/PriceInput";

interface MainFormProps {
  response?: any;
  mode?: any;
  sourceDataParam?: any;
  SourceData?: any;
  setResponse?: any;
  sendDataForCalcAsync?: any;
  contractConstraint?: any;
  salesContractNo?: any;
  setSalesContractNo?: any;
  loading?: boolean;
  salesContractDetail?:any
  setSalesContractDetail?:any
}
export const MainForm = forwardRef(
  (
    {
      response,
      mode,
      sourceDataParam,
      SourceData,
      setResponse,
      sendDataForCalcAsync,
      contractConstraint,
      salesContractNo,
      setSalesContractNo,
      loading,
      salesContractDetail,
      setSalesContractDetail
    }: MainFormProps,
    ref: any
  ) => {
    const [resetForm, setResetForm] = useState(false);

    const [userChanges, setUserChanges] = useState({});
    const [noAccess, setNoAccess] = useState<any>(false);
    const [editor, setEditor] = useState<any>();
    const [editorData, setEditorData] = useState<any>(response?.Conditions);
    const [editorEN, setEditorEN] = useState<any>();
    const [editorDataEN, setEditorDataEN] = useState<any>(
      response?.ConditionsEN
    );
    const [conditionsLang, setConditionsLang] = useState("fa");
    const [customerInfo, setCustomerInfo] = useState<any>(null);
    const [customer, setCustomer] = useState<any>(null);
    const [salesContractDate, setSalesContractDate] = useState<any>();
    const [selectedObj, setSelectedObj] = useState<any>(null);
    const [showForm, setShowForm] = useState(false);
    const formRef = useRef<any>();
    const [showAddressBox, setShowAddressBox] = useState<
      "createMode" | "selectMode" | null
    >(null);
    const [objDictionary, setObjDictionary] = useState<any>({});
    const [showCustomerPhoneForm, setShowCustomerPhoneForm] = useState(false);
    const [showCustomerform, setShowCustomerform] = useState<boolean>(false);
    const [priceList, setPriceList] = useState<any>(null);
    const [currency, setCurrency] = useState<any>(null);

    const [dataGridLoading, setDataGridLoading] = useState<any>(true);
    const [lastWarehouse, setLastWarehouse] = useState<any>(null);
    const [startDate, setStartDate] = useState<any>();
    const [endDate, setEndDate] = useState<any>();

    const [totalRows, setTotalRows] = useState<any>({
      ItemCount: 0,
      TotalTax: 0,
      TotalDiscount: 0,
      SubTotalPrice: 0,
    });
    const [docsClassification, setDocsClassification] = useState<any>(null);
    const [payment, setPayment] = useState<any>({
      TotalPrice: 0,
      Prepayment: 0,
    });
    const [receive, setReceive] = useState<any>({
      GrandTotalPrice: 0,
      Prepayment: 0,
    });
    const [todayDate, settodayDate] = useState<any>(new Date().toISOString());
    const [person, setPerson] = useState<any>(null);
    const [dataChange, setDataChange] = useState<any>(false);

    const [dateLoading, setDateLoading] = useState(true); //for calc fun is runing

    const [detailMode, setDetailMode] = useState<"create" | "edit" | "view">(
      mode
    );

    const [changeAddress, setChangeAddress] = useState<any>();
    const [typePhoneContact, setTypePhonContact] = useState<any>();

    const [selectedPhoneDetail, setSelectedPhoneDetail] = useState<any>({
      phone: "",
      mobile: "",
    });
    const [requiredFields, setRequiredFields] = useState<any>();

    function setSalesContractDetailHandler(data) {
      setDataGridLoading(false);
      setSalesContractDetail(data);
      setDataGridLoading(true);
    }


    const handlesetContractDetail = (newObj) => {
      if (contractConstraint.AllowDuplicateItems || detailMode == "edit") {
        setTotalRows({
          ItemCount:
            detailMode == "create"
              ? RoundOutputOperation(totalRows.ItemCount + +newObj.Qty)
              : RoundOutputOperation(
                  totalRows.ItemCount + (+newObj.Qty - +selectedObj.Qty)
                ),
          TotalTax: contractConstraint.HasTax
            ? detailMode == "create"
              ? totalRows.TotalTax + +newObj.Tax
              : totalRows.TotalTax + (+newObj.Tax - +selectedObj.Tax)
            : 0,
         TotalDiscount:
          detailMode == "create"
            ?( totalRows.TotalDiscount + +newObj.Discount + (newObj.CustomerDiscount?+newObj.CustomerDiscount:0))
            : totalRows.TotalDiscount +
              (+newObj.Discount - +selectedObj.Discount) + (+newObj.CustomerDiscount?+newObj.CustomerDiscount - +selectedObj.CustomerDiscount :0),
          SubTotalPrice:
            detailMode == "create"
              ? totalRows.SubTotalPrice + +newObj.SubTotalPrice
              : totalRows.SubTotalPrice +
                (+newObj.SubTotalPrice - +selectedObj.SubTotalPrice),
        });
                setPayment((e)=>{return  {
           ...e,
        TotalPrice:detailMode == "create"
            ? payment.TotalPrice + +newObj.TotalPrice 
            : payment.TotalPrice +
              (+newObj.TotalPrice - +selectedObj.TotalPrice),
      }} );
        if (detailMode == "create") {
          setSalesContractDetailHandler([...salesContractDetail, newObj]);
        }  else {
                let newItemes = salesContractDetail.map((item: any) => {
                  if (item.Id == newObj.Id) {
                    return newObj;
                    
                  }
                   else if((newObj.Id.replace("changeId","")==item.Id )){
                                return {...newObj , Id: uuidv4()};
                              }
                  else return item;
                });
                setSalesContractDetailHandler(newItemes);
              }
        // Toast("msg_saveddatasuccessfully", "success");
        Toast("msg_saveddatasuccessfully", MessageType.success);

        setDataChange(true);
        return true;
      } else {
        let Dupli = salesContractDetail.find(
          (e: any) => e.ItemId == newObj.ItemId
        );
        if (!Dupli || salesContractDetail.length == 0) {
          setTotalRows({
            ItemCount:
              detailMode == "create"
                ? RoundOutputOperation(totalRows.ItemCount + +newObj.Qty)
                : RoundOutputOperation(
                    totalRows.ItemCount + (+newObj.Qty - +selectedObj.Qty)
                  ),
            TotalTax: contractConstraint.HasTax
              ? detailMode == "create"
                ? totalRows.TotalTax + +newObj.Tax
                : totalRows.TotalTax + (+newObj.Tax - +selectedObj.Tax)
              : 0,
         TotalDiscount:
            detailMode == "create"
              ? totalRows.TotalDiscount + +newObj.Discount + (newObj.CustomerDiscount?+newObj.CustomerDiscount:0)
              : totalRows.TotalDiscount +
                (+newObj.Discount - +selectedObj.Discount)+ (+newObj.CustomerDiscount?+newObj.CustomerDiscount - +selectedObj.CustomerDiscount :0),
            SubTotalPrice:
              detailMode == "create"
                ? totalRows.SubTotalPrice + +newObj.SubTotalPrice
                : totalRows.SubTotalPrice +
                  (+newObj.SubTotalPrice - +selectedObj.SubTotalPrice),
          });
         
          
        setPayment((e)=>{return  {
           ...e,
        TotalPrice:detailMode == "create"
            ? payment.TotalPrice + +newObj.TotalPrice 
            : payment.TotalPrice +
              (+newObj.TotalPrice - +selectedObj.TotalPrice),
      }} );

          if (detailMode == "create") {
            setSalesContractDetailHandler([...salesContractDetail, newObj]);
          } else {
                let newItemes = salesContractDetail.map((item: any) => {
                  if (item.Id == newObj.Id) {
                    return newObj;
                    
                  }
                   else if((newObj.Id.replace("changeId","")==item.Id )){
                                return {...newObj , Id: uuidv4()};
                              }
                  else return item;
                });
                setSalesContractDetailHandler(newItemes);
              }
          // Toast("msg_saveddatasuccessfully", "success");
          Toast("msg_saveddatasuccessfully", MessageType.success);

          setDataChange(true);
          return true;
        } else {
          // Toast("msg_duplicateitems", "error");
          Toast("msg_duplicateitems", MessageType.error);

          return false;
        }
      }
    };

    const handleOpenDetailForm = () => {
      if (priceList) {
        if (customerInfo?.CustomerPersonId || customer?.SundryCustomer) {
          setDetailMode("create");
          setShowForm(true);
        } else {
          // Toast("msg_customernotselected", "error");
          Toast("msg_customernotselected", MessageType.error);
        }
      } else {
        Toast("msg_choosepricelist", MessageType.error);
        // Toast("msg_choosepricelist", "error");
      }
    };

    const selectedObjCallback = (obj, index) => {
      setSelectedObj(obj);
    };

    async function getDefaultPersonContactAsync(personId) {
      try {
        const res2 = await getPersonCustomer(personId);
        setCustomer((pre) => {
          return {
            ...pre,
            Id: res2.Data.Customer.Id,
            Name: res2.Data.Customer.CustomerPersonDescription,
            SundryCustomer:
              res2.Data.Customer.Id == contractConstraint?.SundryCustomerId,
          };
        });
        if (res2.Data.Customer.Id == contractConstraint?.SundryCustomerId) {
          setCustomerInfo({ ...res2?.Data?.Customer });
        } else {
          if (mode != "view") {
            const res = await getDefaultPersonContact(
              res2?.Data?.Customer?.CustomerPositionId
            );
            if (res?.MessageType == MessageType.error && res2?.Data == null) {
            } else setCustomerInfo({ ...res.Data, ...res2?.Data?.Customer });
          } else setCustomerInfo({ ...res2?.Data?.Customer });
        }
      } catch (error) {}
    }


    

    useImperativeHandle(ref, () => ({
      getAllData() {
        if (!formRef.current.reportValidity()) {
          return false;
        } else {
          return {
            Id: response?.Id,
            PriceListId: priceList?.Id,
            PaymentMethodId: formRef.current.PaymentMethodId[0].value,
            CustomerId: customerInfo?.Id,
            SalesContractKindId: formRef.current.SalesContractKindId?.value,
            DocsClassificationId: docsClassification?.Id,
            CurrencyId: currency?.Id,
            SalesManagerPositionId:
              formRef.current.SalesManagerPositionId?.value?formRef.current.SalesManagerPositionId?.value:null,
            VisitorPositionId: formRef.current.VisitorPositionId?.value?formRef.current.VisitorPositionId?.value:null,
            OperatorPositionId: formRef.current.OperatorPositionId?.value?formRef.current.OperatorPositionId?.value:null,
            SalesContractNo: +salesContractNo,
            SalesContractType: +formRef.current.SalesContractType?.value,
            SalesContractDate: salesContractDate,
            ContractingNo: formRef.current.ContractingNo?.value,
            Subject: formRef.current.Subject?.value,
            SubjectEN: contractConstraint?.ShowENFields
              ? formRef.current.SubjectEN?.value
              : null,
            Conditions: editorData,
            ConditionsEN: contractConstraint.ShowENFields ? editorDataEN : null,
            StartDate: startDate,
            EndDate: endDate,
            GoodPerformance:formRef.current.GoodPerformance?.value? +formRef.current.GoodPerformance?.value.replaceAll(
              ",",
              ""
            ):null,
            GoodPerformancePercent:
              +formRef.current.GoodPerformancePercent?.value?+formRef.current.GoodPerformancePercent?.value:null,
            Tolerance: formRef.current.Tolerance?.value?formRef.current.Tolerance?.value:0,
            // ActivityStatus: 0,
            Description: formRef.current.Description?.value,
            DescriptionEN: contractConstraint?.ShowENFields
              ? formRef.current.DescriptionEN?.value
              : null,

            CustomerName: customer?.Name,
            CustomerPhone: customer?.CustomerPhone?.Name.split(":")[1]
              ? customer?.CustomerPhone?.Name.split(":")[1]
              : customer?.CustomerPhone?.Name ?? null,
            CustomerMobilePhone: customer?.CustomerMobilePhone?.Name.split(
              ":"
            )[1]
              ? customer?.CustomerMobilePhone?.Name.split(":")[1]
              : customer?.CustomerMobilePhone?.Name ?? null,
            CustomerAddress: formRef.current.Address?.value,
            CustomerEconNo: formRef.current.CustomerEconNo?.value,
            CustomerNationalCode: formRef.current.CustomerNationalCode?.value,
            DeliveryAddress: formRef.current.DeliveryAddress?.value,
            Prepayment:formRef.current.Prepayment?.value? +formRef.current.Prepayment?.value.replace(',',''):null,
            SubTotalPrice: +totalRows?.SubTotalPrice,
            TotalDiscount: +totalRows?.TotalDiscount,
            TotalPrice: +payment.TotalPrice,
            TotalTax: +totalRows?.TotalTax,
            GrandTotalPrice:
              +payment.TotalPrice + totalRows?.TotalTax,
            IsCurrency: !currency?.IsDefault,
            CurrencyRate: currency?.CurrencyRate,
            SalesManagerPositionDescription:
              objDictionary.SalesManagerPositionDescription,
            VisitorPositionDescription:
              objDictionary.VisitorPositionDescription,
            OperatorPositionDescription:
              objDictionary.OperatorPositionDescription,
            SalesContractDetailDTOList: salesContractDetail,
            ItemCount: +totalRows.ItemCount,
          };
        }
      },
    }));




    const handleDeleteRow = async (id: string = selectedObj.Id) => {
      let newPriceListDetail: any = [...salesContractDetail];
      let obj = newPriceListDetail.filter((e) => e.Id == id)[0];

      setTotalRows((prev) => {
        return {
          ItemCount: RoundOutputOperation(prev.ItemCount - +obj.Qty),
          TotalTax: contractConstraint.HasTax ? prev.TotalTax - +obj.Tax : 0,
          TotalDiscount: prev.TotalDiscount - +obj.Discount - +obj.CustomerDiscount,
          SubTotalPrice: prev.SubTotalPrice - +obj.SubTotalPrice,
        };
      });
         setPayment((e)=>{return  {
           ...e,
        TotalPrice:e.TotalPrice - +obj.TotalPrice,
      }} );
      setSalesContractDetailHandler(
        newPriceListDetail.filter((e) => e.Id != id)
      );
    };

    useEffect(() => {
      if (response?.Id && mode !== "create") {
        let newItemCount = 0;
        response.salesContractDetailDTOList?.map((item) => {
          newItemCount += item.Qty;
        });
        setTotalRows({
          ItemCount: newItemCount,
          TotalTax:  response?.TotalTax,
          TotalDiscount: response?.TotalDiscount,
          SubTotalPrice: response?.SubTotalPrice,
        });
        setPayment({
          TotalPrice: response.TotalPrice,
          Prepayment: response?.Prepayment,
        });
        setReceive({
          GrandTotalPrice: +response?.GrandTotalPrice,
          Prepayment: response?.Prepayment,
        });
        setSalesContractDetail(response.SalesContractDetailDTOList);
      }
    }, [response]);

    // useEffect(() => {
    //   setPayment((prev) => {
    //     return {
    //       ...prev,
    //       TotalPrice: +totalRows.SubTotalPrice - +totalRows.TotalDiscount,
    //     };
    //   });
    // }, [totalRows]);

    useEffect(() => {
      setReceive((prev) => {
        return {
          ...prev,
          GrandTotalPrice: +payment.TotalPrice + +totalRows.TotalTax,
        };
      });
    }, [payment]);

    return (
      <div>
        {showForm ? (
          <ModalForm
            modalHeight={49}
            mode={mode}
            onHide={() => {
              setShowForm(false);
            }}
            show={showForm}
            title={"salesContractDetailForm"}
          >
            <SalesContractDetailForm
              salesWarehouse={contractConstraint?.EcommerceWarehouseId}
              setLastWarehouse={setLastWarehouse}
              lastWarehouse={lastWarehouse}
              mode={detailMode}
              onHide={() => {
                setShowForm(false);
              }}
              priceList={priceList}
              contractConstraint={contractConstraint}
              selectedObj={selectedObj}
              salesContractDetailCallBack={(e) => handlesetContractDetail(e)}
              personId={customerInfo?.CustomerPersonId}
              currency={currency}
              salesContractId={response?.Id}
            />
          </ModalForm>
        ) : (
          <></>
        )}
        {showCustomerPhoneForm ? (
          <ModalForm
            modalHeight={49}
            mode={mode}
            onHide={() => {
              setShowCustomerPhoneForm(false);
            }}
            show={showCustomerPhoneForm}
            title={"CustomerPhoneForm"}
          >
            <CustomerPhoneList
              type={typePhoneContact}
              CustomerPositionId={
                response?.CustomerPositionId
                  ? response?.CustomerPositionId
                  : customerInfo?.CustomerPositionId
              }
              personId={
                response?.CustomerPersonId
                  ? response?.CustomerPersonId
                  : customerInfo?.CustomerPersonId
              }
              onHide={() => {
                setShowCustomerPhoneForm(false);
              }}
              handlePhone={(e) => {
                typePhoneContact == ContactType.Phone
                  ? setSelectedPhoneDetail({ ...selectedPhoneDetail, phone: e })
                  : setSelectedPhoneDetail({
                      ...selectedPhoneDetail,
                      mobile: e,
                    });
              }}
            />
          </ModalForm>
        ) : (
          <></>
        )}

        {showAddressBox ? (
          <ModalForm
            modalHeight={49}
            onHide={() => {
              setShowAddressBox(null);
            }}
            mode={mode}
            show={showAddressBox && true}
            title={"Address"}
          >
            <AddressBox
              personId={
                response?.CustomerPersonId
                  ? response.CustomerPersonId
                  : customerInfo?.CustomerPersonId
              }
              CustomerPositionId={
                response?.CustomerPositionId
                ? response.CustomerPositionId
                : customerInfo?.CustomerPositionId
              }
              onHide={() => {
                setShowAddressBox(null);
              }}
              status={showAddressBox}
              AddressHandeler={(e) => {
                setChangeAddress(JSON.stringify(e).toLowerCase());
                setCustomerInfo({
                  ...customerInfo,
                  Address: JSON.stringify(e).toLowerCase(),
                });
                setShowAddressBox(null);
              }}
            />
          </ModalForm>
        ) : (
          <></>
        )}

        {showCustomerform ? (
          <ModalForm
            modalHeight={49}
            mode={mode}
            onHide={() => {
              setShowCustomerform(false);
            }}
            show={showCustomerform}
            title={"Customer"}
          >
            <CustomerTabform
              setCustomerCallBack={(e) => {
                setResponse({ ...response, CustomerId: e });
              }}
              selectedObj={customer}
              mode={mode}
              onHide={() => {
                setShowCustomerform(false);
              }}
            />
          </ModalForm>
        ) : (
          <></>
        )}

        <form
          // onSubmit={handlesalesContractDetailFormSubmit}
          ref={formRef}
        >
          <div className="col-12 mb-3 mt-1">
            <div className="d-flex justify-content-end">
              <div className="col-lg-12  btns_form"></div>
            </div>
          </div>
          <FormWithTitle
            title={trans("SalesContract")}
            defualtClose={true}
            showFristRow={true}
            closeOption={true}
            dynamicTitle={{
              CustomerName: customer?.Name,
              salesContractno: salesContractNo
                ? salesContractNo
                : response?.SalesContractNo
                ? response?.SalesContractNo
                : contractConstraint?.DocNo,
                ...(response?.JobNo && { JobNo: response?.JobNo })
            }}
          >
            <div className="card-body" style={{paddingTop:'1px'}}>
              <div className="row ">
                <div className="col-lg-1 col-11">
                  <Textbox
                    textboxType="text"
                    textboxName="salesContractNo"
                    labelText="number"
                    defaultValue={
                      response
                        ? response.SalesContractNo
                        : contractConstraint.DocNo
                    }
                    resetForm={resetForm}
                    readonly={!contractConstraint.IsDocNoEditable}
                    onChange={(e) => {
                      setSalesContractNo(e.target.value);
                    }}
                    mode={mode}
                  />
                </div>

                {contractConstraint?.IsDocClassified && (
                  <div className="col-lg-2 col-11 me-lg-3 mt-3 mt-lg-0">
                    <DocsClassification
                      label="Classification"
                      name="docsClassificationId"
                      baseUrl={INVENTORYANDSALES_URL}
                      IsDocClassified={contractConstraint?.IsDocClassified}
                      endPoint={
                        ENDPOINTSINVENTORYANDSALES.Sales
                          .BaseDefinitionAndSetting.SalesDocsClassification
                          .dictionary
                      }
                      resetForm={resetForm}
                      value={
                        docsClassification
                          ? docsClassification?.Id
                          : response?.DocsClassificationId
                      }
                      mode={mode}
                      onChange={(e, obj) => {
                        // if((docsClassification?.CalculateTax!=obj?.CalculateTax)&&docsClassification!=null){sendDataForCalcAsync(null , obj) }else
                        setDocsClassification(obj);
                      }}
                    />
                  </div>
                )}
                {dateLoading && (
                  <>
                    <div className="col-lg-1 col-11">
                      <Datepicker
                        mode={
                          contractConstraint.IsNewDocCurrentDate ? "view" : mode
                        }
                        lable="Date"
                        setIsoTime={(isoTime: string) => {
                          setSalesContractDate(isoTime);
                        }}
                        required={true}
                        val={
                          response
                            ? response.SalesContractDate
                            : contractConstraint.IsNewDocCurrentDate
                            ? todayDate
                            : null
                        }
                        errorFlag={false}
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                      />
                    </div>

                    <div className="col-lg-1 col-11">
                      <Datepicker
                        mode={
                          // contractConstraint.IsNewDocCurrentDate ? "view" : mode
                          mode
                        }
                        lable="StartDate"
                        setIsoTime={(isoTime: string) => {
                          setStartDate(isoTime);
                        }}
                        required={true}
                        val={
                          // response
                          // ?
                          response?.StartDate
                          // : contractConstraint.IsNewDocCurrentDate
                          // ? todayDate
                          // : null
                        }
                        errorFlag={false}
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                      />
                    </div>
                    <div className="col-lg-1 col-11">
                      <Datepicker
                        mode={
                          // contractConstraint.IsNewDocCurrentDate ? "view" : mode
                          mode
                        }
                        lable="EndDate"
                        setIsoTime={(isoTime: string) => {
                          setEndDate(isoTime);
                        }}
                        required={true}
                        val={
                          // response
                          // ?
                          response?.EndDate
                          // : contractConstraint.IsNewDocCurrentDate
                          // ? todayDate
                          // : null
                        }
                        errorFlag={false}
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                      />
                    </div>
                  </>
                )}
                <div className="col-lg-2 row col-11">
                  <CustomerDictionary
                  
                    checkHasAccess={() => setNoAccess(true)}
                    name="CustomerName"
                    label="CustomerName"
                    resetForm={resetForm}
                    value={response?.CustomerId}
                    ShowMethod={contractConstraint?.ChangeDocCustomer}
                    CustomerName={response?.CustomerName}
                    mode={mode}
                    returnObj={true}
                    required={true}
                    onChange={(e) => {
                      if (e.Id) {
                        setCustomer((prev) => {
                          return { ...e, ...prev };
                        });
                        getDefaultPersonContactAsync(e.Id);
                      } else {
                        setCustomerInfo(null);
                        setCustomer(null);
                      }
                    }}
                  />
                  {mode == "create" && !noAccess && (
                    <div
                      style={{
                        marginTop: "25px",
                        width: "1%",
                        marginRight: "-25px",
                      }}
                    >
                      <Button
                        Icon={true}
                        value={
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              setShowCustomerform(true);
                            }}
                            className="checkButton d-flex align-items-center justify-content-center"
                          >
                            {" "}
                            <FontAwesomeIcon
                              icon={[ICON_TYPE, "plus"]}
                              size="2x"
                            />
                          </button>
                        }
                        btnType="primary"
                      />
                    </div>
                  )}
                </div>
                <>
                  <div className="col-lg-2 col-11 me-lg-4">
                    <PriceListDictionary
                      name="PriceList"
                      label="PriceList"
                      resetForm={resetForm}
                      value={
                        contractConstraint.UseCustomerPriceList &&
                        customerInfo?.PriceListId
                          ? customerInfo.PriceListId
                          : priceList == null ||
                            !priceList ||
                            priceList.Id == GUID_EMPTY
                          ? response?.PriceListId
                          : priceList.Id
                      }
                      mode={
                        contractConstraint.UseCustomerPriceList &&
                        customerInfo?.PriceListId
                          ? "view"
                          : mode
                      }
                      onChange={(e) => {
                        !!salesContractDetail.length &&
                        e.Id != GUID_EMPTY &&
                        response?.PriceListId != e.Id
                          ? sendDataForCalcAsync(e)
                          : setPriceList(e);
                      }}
                    />
                  </div>
                  <div className="col-lg-2">
                    <DictionarySelectBox
                      label="PaymentMethod"
                      name="PaymentMethodId"
                      baseUrl={INVENTORYANDSALES_URL}
                      endPoint={
                        ENDPOINTSINVENTORYANDSALES.Sales
                          .BaseDefinitionAndSetting.PaymentMethod.dictionary
                      }
                      resetForm={resetForm}
                      value={response?.PaymentMethodId}
                      mode={mode}
                    />
                  </div>
                  <div className="col-lg-2 col-11 mr-2">
                    <Position
                      onChange={(e) => {
                        setObjDictionary({
                          ...objDictionary,
                          VisitorPositionDescription: e.Name,
                        });
                      }}
                      name="VisitorPositionId"
                      label="VisitorPosition"
                      resetForm={resetForm}
                      value={response?.VisitorPositionId}
                      mode={mode}
                      returnObj={true}
                    />
                  </div>
                  <div className="col-lg-4 col-sm-4 mt-1">
                    <Position
                      onChange={(e) => {
                        setObjDictionary({
                          ...objDictionary,
                          OperatorPositionDescription: e.Name,
                        });
                      }}
                      name="OperatorPositionId"
                      label="OperatorPosition"
                      mode={mode}
                      value={response?.OperatorPositionId}
                      resetForm={resetForm}
                    />
                  </div>
                  <div className="col-lg-2">
                    <DictionarySelectBox
                      label="SalesContractKind"
                      name="SalesContractKindId"
                      baseUrl={INVENTORYANDSALES_URL}
                      endPoint={
                        ENDPOINTSINVENTORYANDSALES.Sales.SalesContract
                          .kindDictionary
                      }
                      resetForm={resetForm}
                      value={response?.SalesContractKindId}
                      mode={mode}
                    />
                  </div>
                  <div className="col-lg-2 col-11">
                    <Position
                      onChange={(e) => {
                        setObjDictionary({
                          ...objDictionary,
                          SalesManagerPositionDescription: e.Name,
                        });
                      }}
                      name="SalesManagerPositionId"
                      label="SalesManagerPosition"
                      resetForm={resetForm}
                      value={response?.SalesManagerPositionId}
                      mode={mode}
                      returnObj={true}
                    />
                  </div>
                  <div className="col-lg-1 col-11 ">
                    <CurrencyDictionary
                      name="CurrencyId"
                      label="Currency"
                      onChange={(e) => {
                        setCurrency(e);
                      }}
                      resetForm={resetForm}
                      value={
                        priceList?.CurrencyId
                          ? priceList.CurrencyId
                          : response?.CurrencyId
                      }
                      mode={priceList?.CurrencyId ? "view" : mode}
                      required={true}
                    />
                  </div>
                </>

                <div className="col-lg-2 col-11 me-lg-4">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxType="text"
                    textboxName="CustomerEconNo"
                    labelText="CustomerEconNo"
                    defaultValue={
                      response?.CustomerEconNo
                        ? response.CustomerEconNo
                        : customerInfo?.EconNo
                    }
                    resetForm={resetForm}
                    mode={mode}
                  />
                </div>

                <div className="col-11 col-lg-2 d-flex">
                  <div className="flex-grow-1">
                    <CustomerPhoneDictionary
                      required={requiredFields?.CustomerPhone}
                      type={ContactType.Phone}
                      name="CustomerPhone"
                      label="CustomerPhone"
                      resetForm={resetForm}
                      valueString={
                        response?.CustomerPhone || mode !== "create"
                          ? response?.CustomerPhone
                          : selectedPhoneDetail.phone.Value ??
                            customerInfo?.PhoneNumber
                      }
                      mode={mode}
                      returnObj={true}
                      CustomerPositionId={
                        response?.CustomerPositionId
                          ? response?.CustomerPositionId
                          : customerInfo?.CustomerPositionId
                      }
                      onChange={(e) => {
                        setCustomer((prev) => {
                          return { ...prev, CustomerPhone: e };
                        });
                      }}
                    />
                  </div>

                  {mode != "view" && (
                    <div
                      style={{
                        marginTop: "25px",
                        width: "1%",
                        // marginRight: "-25px",
                      }}
                      className="ms-4"
                    >
                      <Button
                        Icon={true}
                        value={
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              setShowCustomerPhoneForm(true);
                              setTypePhonContact(ContactType.Phone);
                            }}
                            className="checkButton d-flex align-items-center justify-content-center"
                          >
                            <FontAwesomeIcon
                              icon={[ICON_TYPE, "plus"]}
                              size="2x"
                            />
                          </button>
                        }
                        btnType="primary"
                      />
                    </div>
                  )}
                </div>

                <div className="col-11 col-lg-2 d-flex">
                  <div className="flex-grow-1">
                    <CustomerPhoneDictionary
                      required={requiredFields?.CustomerMobilePhone}
                      type={ContactType.Mobile}
                      name="CustomerMobilePhone"
                      label="CustomerMobilePhone"
                      resetForm={resetForm}
                      valueString={
                        response?.CustomerMobilePhone || mode !== "create"
                          ? response?.CustomerMobilePhone
                          : selectedPhoneDetail.mobile?.Value ??
                            customerInfo?.MobilePhone
                      }
                      mode={mode}
                      returnObj={true}
                      CustomerPositionId={
                        response?.CustomerPositionId
                          ? response.CustomerPositionId
                          : customerInfo?.CustomerPositionId
                      }
                      onChange={(e) => {
                        setCustomer((prev) => {
                          return { ...prev, CustomerMobilePhone: e };
                        });
                      }}
                      Change={() => {}}
                    />
                  </div>
                  {mode != "view" && (
                    <div
                      style={{
                        marginTop: "25px",
                        width: "1%",
                        // marginRight: "-25px",
                      }}
                      className="ms-4"
                    >
                      <Button
                        Icon={true}
                        value={
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              setShowCustomerPhoneForm(true);
                              setTypePhonContact(ContactType.Mobile);
                            }}
                            className="checkButton d-flex align-items-center justify-content-center"
                          >
                            <FontAwesomeIcon
                              icon={[ICON_TYPE, "plus"]}
                              size="2x"
                            />
                          </button>
                        }
                        btnType="primary"
                      />
                    </div>
                  )}
                </div>

                <div className="col-lg-3 col-11">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="CustomerNationalCode"
                    textboxType="nationalCode"
                    labelText="CustomerNationalCode"
                    defaultValue={
                      response?.CustomerNationalCode
                        ? response.CustomerNationalCode
                        : customerInfo?.NationalId?.trim()
                    }
                    resetForm={resetForm}
                    mode={mode}
                    required={requiredFields?.CustomerNationalCode}
                  />
                </div>
                <div className="col-lg-3 col-11">
                  <Textbox
                
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="Tolerance"
                    textboxType="text"
                    labelText="Tolerance"
                    defaultValue={response?.Tolerance}
                    resetForm={resetForm}
                    mode={mode}
                    // required={requiredFields?.Tolerance}
                  />
                </div>
                <div className="col-lg-3 col-11">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="Subject"
                    textboxType="text"
                    labelText="Subject"
                    defaultValue={response?.Subject}
                    resetForm={resetForm}
                    mode={mode}
                    required={requiredFields?.Subject}
                  />
                </div>
                {contractConstraint?.ShowENFields && (
                  <div className="col-lg-3 col-11">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="SubjectEN"
                      textboxType="text"
                      labelText="SubjectEN"
                      defaultValue={response?.SubjectEN}
                      resetForm={resetForm}
                      mode={mode}
                      required={requiredFields?.SubjectEN}
                    />
                  </div>
                )}
             

                <div className="col-lg-3 col-11">
                  <EnumerationTypeSelect
                    label="SalesContract"
                    enumTypeSelect="SalesContractType"
                    name="SalesContractType"
                    value={null}
                    defaultValue={response?.SalesContractType}
                  />
                </div>

                <div className="col-lg-5 col-11 d-flex ">
                  <div className="flex-grow-1">
                    <Address
                      onChange={(e) => {
                        setShowAddressBox("selectMode");
                        return false;
                      }}
                      withMap={false}
                      hideDetail={true}
                      personContact={
                        changeAddress
                          ? convertAddress(changeAddress)
                          : response?.CustomerAddress
                          ? response?.CustomerAddress
                          : convertAddress(customerInfo?.Address)
                      }
                      mode={"view"}
                      required={requiredFields?.CustomerAddress}
                    />
                  </div>

                  {mode != "view" && (
                    <>
                      <div
                        style={{
                          marginTop: "25px",
                          width: "1%",
                          // marginRight: "-25px",
                        }}
                        className="ms-4"
                      >
                        <Button
                          Icon={true}
                          value={
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                setShowAddressBox("createMode");
                              }}
                              className="checkButton d-flex align-items-center justify-content-center"
                            >
                              {" "}
                              <FontAwesomeIcon
                                icon={[ICON_TYPE, "plus"]}
                                size="2x"
                              />
                            </button>
                          }
                          btnType="primary"
                        />
                      </div>
                      {mode !== "view" && (
                        <div
                          style={{
                            marginTop: "25px",
                            width: "1%",
                            // marginRight: "5px",
                            marginLeft: "20px",
                          }}
                          className="ms-4"
                        >
                          <Button
                            Icon={true}
                            value={
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowAddressBox("selectMode");
                                }}
                                className="checkButton d-flex align-items-center justify-content-center"
                              >
                                {" "}
                                <FontAwesomeIcon
                                  icon={[ICON_TYPE, "search"]}
                                  size="2x"
                                />
                              </button>
                            }
                            btnType="primary"
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>

                <div className="col-lg-3 col-11">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="DeliveryAddress"
                    textboxType="text"
                    labelText="DeliveryAddress"
                    defaultValue={
                      response?.DeliveryAddress ? response.DeliveryAddress : ""
                    }
                    resetForm={resetForm}
                    mode={mode}
                    required={requiredFields?.DeliveryAddress}
                  />
                </div>
                <div className="col-lg-5 col-11">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="Description"
                    textboxType="textarea"
                    labelText="Description"
                    minHeight={1}
                    defaultValue={response?.Description}
                    resetForm={resetForm}
                    mode={mode}
                    maxLength={900}
                    letterCounter={true}
                    required={requiredFields?.Description}
                  />
                </div>
                {contractConstraint?.ShowENFields && (
                  <div className="col-lg-5 col-11">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="DescriptionEN"
                      textboxType="textarea"
                      labelText="DescriptionEN"
                      minHeight={1}
                      defaultValue={response?.DescriptionEN}
                      resetForm={resetForm}
                      mode={mode}
                      maxLength={900}
                      letterCounter={true}
                      required={requiredFields?.DescriptionEN}
                    />
                  </div>
                )}
              </div>
                 <div className="w-100 mt-3"></div>
                {contractConstraint?.ShowENFields && (
                  <div className="col-8 row mb-2 ">
                    <div className="col-6 my-1 my-lg-0 col-lg-4">
                      <CheckableButton
                        onchange={() => setConditionsLang("fa")}
                        type="radio"
                        labelText="ConditionsAndTerms"
                        defaultChecked={conditionsLang == "fa"}
                        defaultValue={conditionsLang == "fa"}
                        value={conditionsLang == "fa"}
                        inputName="conditionsLang"
                        mode={mode}
                      />
                    </div>
                    <div className="col-6 my-1 my-lg-0 col-lg-4">
                      <CheckableButton
                        onchange={() => setConditionsLang("en")}
                        type="radio"
                        labelText="ConditionsAndTermsEN"
                        defaultChecked={conditionsLang == "en"}
                        defaultValue={conditionsLang == "en"}
                        value={conditionsLang == "en"}
                        inputName="conditionsLang"
                        mode={mode}
                      />
                    </div>
                  </div>
                )}
                 {(!contractConstraint?.ShowENFields ||
                  (contractConstraint?.ShowENFields &&
                    conditionsLang == "fa")) && (
                  <div className="col-12 mb-3">
                    <span>{trans("ConditionsAndTerms")}</span>
                    <CKEditor
                      data={editorData}
                      disabled={mode == "view" && "true"}
                      onReady={(editor) => {
                        editor.ui
                          .getEditableElement()
                          .parentElement.insertBefore(
                            editor.ui.view.toolbar.element,
                            editor.ui.getEditableElement()
                          );
                        setEditor(editor);
                      }}
                      onError={(error, { willEditorRestart }) => {
                        if (willEditorRestart) {
                          editor.ui.view.toolbar.element.remove();
                        }
                      }}
                      onOk={(editor) => {
                        editor.insertHtml(editorData);
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setEditorData(data);
                      }}
                      editor={DecoupledEditor}
                      config={{
                        removePlugins: [
                          "EasyImage",
                          "ImageUpload",
                          "MediaEmbed",
                        ],
                      }}
                    />
                  </div>
                )}

                {contractConstraint?.ShowENFields && conditionsLang == "en" && (
                  <div className="col-12 mb-3">
                    <span>{trans("ConditionsAndTermsEN")}</span>
                    <CKEditor
                      data={editorDataEN}
                      disabled={mode == "view" && "true"}
                      onReady={(editor) => {
                        editor.ui
                          .getEditableElement()
                          .parentElement.insertBefore(
                            editor.ui.view.toolbar.element,
                            editor.ui.getEditableElement()
                          );
                        setEditorEN(editor);
                      }}
                      onError={(error, { willEditorRestart }) => {
                        if (willEditorRestart) {
                          editorEN.ui.view.toolbar.element.remove();
                        }
                      }}
                      onOk={(editor) => {
                        editor.insertHtml(editorDataEN);
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setEditorDataEN(data);
                      }}
                      editor={DecoupledEditor}
                      config={{
                        removePlugins: [
                          "EasyImage",
                          "ImageUpload",
                          "MediaEmbed",
                        ],
                      }}
                    />
                  </div>
                )}
            </div>
          </FormWithTitle>
          <div className="mt-3">
            <FormWithTitle title={trans("TaxSystem")}>
              <div>
                <div className="col-lg-2 ">
                  {/* <Textbox
                    useGroupingPrice={true}
                    textboxName="ContractingNo"
                    textboxType="text"
                    labelText="ContractingNo"
                    defaultValue={response?.ContractingNo}
                    resetForm={resetForm}
                    mode={"view"}
                  /> */}
                  <PriceInput
                    name="ContractingNo"
                    label="ContractingNo"
                    defaultValue={response?.ContractingNo}
                    resetForm={resetForm}
                    mode={"view"}
                  />
                </div>
              </div>
            </FormWithTitle>
          </div>
          <div className="mt-3">
            <FormWithTitle title={trans("Details")}>
              <div>
                <div className="row justify-content-between">
                  {mode != "view" && (
                    <div
                      onClick={handleOpenDetailForm} ////////
                      className="col-2 mb-1 btn btn-success btn-sm d-flex align-items-center justify-content-between "
                      style={{
                        width: "70px",
                        maxHeight: "30px",
                        marginRight: "20px",
                        minWidth: "70px",
                      }}
                    >
                      <>
                        <span className=" font-size-md ms-2 ">
                          {trans("add")}
                        </span>
                        <FontAwesomeIcon
                          size="xs"
                          icon={["fas", "plus"]}
                          className="color_text_light d-flex Requests__chatbox-reply-btn mx-1 p-1"
                          color="white"
                        />
                      </>
                    </div>
                  )}
                  <div
                    className={`
                
                         "col-10"
                       row `}
                  >
                    <div className="d-flex justify-content-end align-items-center">
                      <div
                        className={`col-12
                        row justify-content-end mb-1`}
                      >
                        <Headerbar
                          withPading={false}
                          headerContents={   (contractConstraint.HasTax && mode=='create') || mode!='create'?totalRows:{...totalRows,TotalTax:0}}
                          hasBorder={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {dataGridLoading ? (
                  <>
                    {(
                      mode == "view"
                        ? salesContractDetail.length > 0
                        : contractConstraint.DetailDTO
                    ) ? (
                      <>
                        <DataGrid
                          useChangingNumberPlacement={true}
                          useLanguage={true}
                          convertDateColNames={["ExpireDate"]}
                          DoubleClick={(e) => {
                            setSelectedObj(e);
                            setShowForm(true);
                            setDetailMode("view");
                          }}
                          decimalColumn={['UnitPrice','SubTotalPrice']}
                          parentName={"salesContractDetailList"}
                          startIndex={10}
                          theadData={
                            mode !== "view"
                              ? Object.keys(contractConstraint.DetailDTO)
                              : Object.keys(salesContractDetail[0])
                          }
                          tbodyData={
                            salesContractDetail?.length > 0
                              ? salesContractDetail
                              : [contractConstraint.DetailDTO]
                          }
                          totalRecords={
                            salesContractDetail?.length > 0 ? undefined : 0
                          }
                          scrollHeight={"67vh"}
                          minCellWidth={80}
                          selectedRowObjectCallback={selectedObjCallback}
                          handleEdit={
                            mode != "view"
                              ? (e) => {
                                  setSelectedObj(e);
                                  setDetailMode("edit");
                                  setShowForm(true);
                                }
                              : undefined
                          }
                          rowSelected={selectedObj}
                          handleDelete={
                            mode != "view"
                              ? (e) => {
                                  // Toast(
                                  //   trans("msg_deleteconfirm"),
                                  //   "warning",
                                  //   "alert",
                                  //   () => handleDeleteRow(e)
                                  // );
                                  Toast(
                                    trans("msg_deleteconfirm"),
                                    MessageType.confirmDelete,
                                    () => handleDeleteRow(e)
                                  );
                                }
                              : undefined
                          }
                          handleView={(e) => {
                            setSelectedObj(e);
                            setDetailMode("view");
                            setShowForm(true);
                          }}
                        />
                      </>
                    ) : (
                      <Message message={"NoDataForPreview"} type={"info"} />
                    )}
                  </>
                ) : (
                  <Loading />
                )}
              </div>
            </FormWithTitle>
          </div>

          <div className="card">
            <div className="card-body ">
              <div className="row">
                <>
                  <div className="col-lg-2 ">
                    {/* <Textbox
                    required={true}
                      useGroupingPrice={true}
                      textboxName="TotalPrice"
                      textboxType="text"
                      labelText="TotalPrice"
                      decimals={currency?.PriceRoundingPlace}
                      round={contractConstraint.FloorTaxDuty}
                      defaultValue={
                        payment.TotalPrice != 0
                          ? payment.TotalPrice + ""
                          : response?.TotalPrice
                          ? response?.TotalPrice + ""
                          : payment.TotalPrice
                      }
                      resetForm={resetForm}
                      mode={"view"}
                    /> */}
                    <PriceInput
                        required={true}
                      name="TotalPrice"
                      label="TotalPrice"
                      decimals={currency?.PriceRoundingPlace}
                      round={contractConstraint.FloorTaxDuty}
                      defaultValue={
                        payment.TotalPrice != 0
                          ? payment.TotalPrice + ""
                          : response?.TotalPrice
                          ? response?.TotalPrice + ""
                          : payment.TotalPrice
                      }
                      resetForm={resetForm}
                      mode={"view"}
                    />
                  </div>

                  <div className="col-lg-2">
                    {/* <Textbox
                    required={true}
                      useGroupingPrice={true}
                      textboxName="GrandTotalPrice"
                      decimals={currency?.PriceRoundingPlace}
                      round={contractConstraint.FloorTaxDuty}
                      textboxType="text"
                      labelText="GrandTotalPrice"
                      defaultValue={
                        receive?.GrandTotalPrice != 0
                          ? receive?.GrandTotalPrice + ""
                          : response?.GrandTotalPrice
                          ? response?.GrandTotalPrice + ""
                          : receive?.GrandTotalPrice
                      }
                      resetForm={resetForm}
                      mode={"view"}
                    /> */}
                    <PriceInput
                     required={true}
                      name="GrandTotalPrice"
                      decimals={currency?.PriceRoundingPlace}
                      // round={contractConstraint.FloorTaxDuty}
                      label="GrandTotalPrice"
                      defaultValue={
                        receive?.GrandTotalPrice != 0
                          ? receive?.GrandTotalPrice + ""
                          : response?.GrandTotalPrice
                          ? response?.GrandTotalPrice + ""
                          : receive?.GrandTotalPrice
                      }
                      resetForm={resetForm}
                      mode={"view"}
                    />
                  </div>
                  <div className="col-lg-2">
                    {/* <Textbox
                      useGroupingPrice={true}
                      textboxName="GoodPerformance"
                      decimals={currency?.PriceRoundingPlace}
                      round={contractConstraint.FloorTaxDuty}
                      textboxType="text"
                      labelText="GoodPerformance"
                      defaultValue={response?.GoodPerformance}
                      resetForm={resetForm}
                      mode={mode}
                    /> */}
                    <PriceInput
                      name="GoodPerformance"
                      label="GoodPerformance"
                      decimals={currency?.PriceRoundingPlace}
                      round={contractConstraint.FloorTaxDuty}
                      defaultValue={response?.GoodPerformance}
                      resetForm={resetForm}
                      mode={mode}
                    />
                  </div>
                  <div className="col-lg-2">
                    <Textbox
                      textboxName="GoodPerformancePercent"
                      textboxType="number"
                      labelText="GoodPerformancePercent"
                      defaultValue={response?.GoodPerformancePercent + ""}
                      resetForm={resetForm}
                      mode={mode}
                    />
                  </div>
                  <div className="col-lg-2">
                    {/* <Textbox
                    required={true}
                      textboxName="Prepayment"
                      textboxType="text"
                      labelText="Prepayment"
                      useGroupingPrice={true}
                      defaultValue={
                        receive?.Prepayment != 0
                          ? receive?.Prepayment + ""
                          : response?.Prepayment
                          ? response?.Prepayment + ""
                          : receive?.Prepayment
                      }
                      onChange={(e) => {
                        setReceive({
                          ...receive,
                          Prepayment: e.target.value.replaceAll(",", ""),
                        });
                      }}
                      resetForm={resetForm}
                      mode={mode}
                    /> */}
                    <PriceInput
                         required={true}
                      name="Prepayment"
                      label="Prepayment"
                      defaultValue={
                        receive?.Prepayment != 0
                          ? receive?.Prepayment + ""
                          : response?.Prepayment
                          ? response?.Prepayment + ""
                          : receive?.Prepayment
                      }
                      onChange={(e) => {
                        setReceive({
                          ...receive,
                          Prepayment: e.target.value.replaceAll(",", ""),
                        });
                      }}
                      resetForm={resetForm}
                      mode={mode}
                    />
                  </div>

                  <div className={"col-lg-1"}>
                    <DictionarySelectBox
                      label="PaymentMethod"
                      name="PaymentMethodId"
                      baseUrl={INVENTORYANDSALES_URL}
                      endPoint={
                        ENDPOINTSINVENTORYANDSALES.Sales
                          .BaseDefinitionAndSetting.PaymentMethod.dictionary
                      }
                      resetForm={resetForm}
                      value={response?.PaymentMethodId}
                      mode={mode}
                    />
                  </div>
                </>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
);
